import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PublicHeader.css';

const PublicHeader = ({ jobCount = 0 }) => {
  const navigate = useNavigate();

  return (
    <header className="public-header">
      <div className="public-header-content">
        <div className="public-logo-group" onClick={() => navigate('/')}>
          <img
            src="https://securelayer7.net/assets/image/recent/sl7-logo.svg"
            alt="SecureLayer7"
            className="public-logo-img"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <div className="public-logo-text">
            <span className="public-logo-name">SecureLayer7</span>
            <span className="public-logo-sub">Careers</span>
          </div>
        </div>
        <nav className="public-nav">
          <a href="https://securelayer7.net" target="_blank" rel="noopener noreferrer" className="nav-link company-link">
            About Us
          </a>
          <a href="https://blog.securelayer7.net" target="_blank" rel="noopener noreferrer" className="nav-link company-link">
            Blog
          </a>
          {jobCount > 0 && (
            <button onClick={() => navigate('/#jobs')} className="nav-link careers">
              Open Positions
              <span className="nav-job-count">{jobCount}</span>
            </button>
          )}
          <button onClick={() => navigate('/login')} className="nav-link sign-in">
            Sign In
          </button>
        </nav>
      </div>
      <div className="public-header-notice">
        SecHire is the official hiring platform of <a href="https://securelayer7.net" target="_blank" rel="noopener noreferrer">SecureLayer7</a> — a dedicated space to find, assess, and hire security talent.
      </div>
    </header>
  );
};

export default PublicHeader;
